import MailIcon from "@/assets/icons/envelope.svg";
import { cx } from "@/utils";
import AccessControl from "@components/AccessControl";
import Button, { ButtonProps } from "@components/Button";

import styles from "./ReportBuilder.module.css";

type ScheduleButtonProps = {
  className?: string;
  subscribers?: unknown[];
} & ButtonProps;

const ScheduleButton: React.FunctionComponent<ScheduleButtonProps> = ({
  className,
  subscribers = [],
  ...props
}) => {
  const numSubscribers = subscribers?.length;

  let label;

  if (numSubscribers === 0)
    label = L.REPORTS_SCHEDULE_NOT_SCHEDULED_BUTTON_LABEL;
  else if (numSubscribers === 1)
    label = L.REPORTS_SCHEDULE_SCHEDULED_SINGULAR_BUTTON_LABEL;
  else
    label = `${numSubscribers} ${L.REPORTS_SCHEDULE_SCHEDULED_PLURAL_BUTTON_LABEL}`;

  return (
    <AccessControl>
      <Button
        variant="secondary"
        size="sm"
        className={cx(styles.schedule, className)}
        icon={MailIcon}
        {...props}
      >
        <span className="inline sm:hidden">
          {L.REPORTS_SCHEDULE_SMALL_SCREENS_BUTTON_LABEL}
        </span>
        <span className="hidden sm:inline">{label}</span>
      </Button>
    </AccessControl>
  );
};

export default ScheduleButton;
